import { GTFonts } from '../../theme';
import { fs, v } from '../../utils/libs';

/**
 * The look of a list table's head row (Inventory's, shared by Staff,
 * Customers and Suppliers): white, 40px tall, a grey line under it and bold
 * normal-case labels. Each screen adds its own row direction and padding so
 * the columns line up with its rows.
 */
export const createTableHeadStyles = (theme: any) => ({
  head: {
    minHeight: v(40),
    backgroundColor: theme.colors.surface,
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.borderGray200,
  },
  headText: {
    fontFamily: GTFonts.bold,
    fontSize: fs(13),
    lineHeight: fs(18),
    color: theme.colors.text,
  },
});
